import { render, staticRenderFns } from "./UploadHolidayFormCard.vue?vue&type=template&id=63a366bb&"
import script from "./UploadHolidayFormCard.vue?vue&type=script&lang=ts&"
export * from "./UploadHolidayFormCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports